import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=51c8d42d&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=51c8d42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8d42d",
  null
  
)

export default component.exports